import { j as o, c as L } from "../../utils-BdNIfrGQ.js";
import * as r from "react";
import st, { useCallback as at } from "react";
import * as Ne from "react-dom";
import { u as Te, P as j, c as N, a as lt, b as it } from "../../index-wif4gfZf.js";
import { c as ct } from "../../index-D6CDIecL.js";
import { u as k } from "../../index-DLcqcWxM.js";
import { u as dt } from "../../index-fVZ4qWjb.js";
import { P as ut, D as pt } from "../../index-B9Qoa2iP.js";
import { h as ft, u as mt, R as ht, F as vt } from "../../Combination-CNeqR4sO.js";
import { u as be } from "../../index-Cv867SGx.js";
import { R as gt, A as xt, c as Re, C as St, a as wt } from "../../index-NCB3MGjP.js";
import { u as Ct } from "../../index-0ioNhtNM.js";
import { u as G } from "../../index-CCKe-Mpx.js";
import { u as yt } from "../../index-BZPx6jYI.js";
import { a as bt } from "../../index-CXtjncBb.js";
import { C as _e } from "../../chevron-down-DgT-uSF9.js";
import { C as It } from "../../check-BxlvVsvD.js";
import { c as Tt } from "../../createLucideIcon-D4r5Phnh.js";
import { n as Pt } from "../../normalize-spacing-DY0KSpr_.js";
import { L as Nt } from "../../Label-kWLyCHVQ.js";
import { D as Rt } from "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import { c as _t } from "../../index-Di82Y7n3.js";
const Et = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], jt = Tt("chevron-up", Et);
function Pe(t, [n, e]) {
  return Math.min(e, Math.max(n, t));
}
var Mt = [" ", "Enter", "ArrowUp", "ArrowDown"], At = [" ", "Enter"], Q = "Select", [ce, de, Ot] = ct(Q), [oe] = lt(Q, [
  Ot,
  Re
]), ue = Re(), [Dt, Y] = oe(Q), [Lt, kt] = oe(Q), Ee = (t) => {
  const {
    __scopeSelect: n,
    children: e,
    open: c,
    defaultOpen: l,
    onOpenChange: d,
    value: s,
    defaultValue: a,
    onValueChange: i,
    dir: p,
    name: v,
    autoComplete: x,
    disabled: I,
    required: b,
    form: S
  } = t, u = ue(n), [h, w] = r.useState(null), [m, g] = r.useState(null), [z, M] = r.useState(!1), ne = dt(p), [R, O] = Te({
    prop: c,
    defaultProp: l ?? !1,
    onChange: d,
    caller: Q
  }), [W, X] = Te({
    prop: s,
    defaultProp: a,
    onChange: i,
    caller: Q
  }), B = r.useRef(null), V = h ? S || !!h.closest("form") : !0, [K, H] = r.useState(/* @__PURE__ */ new Set()), F = Array.from(K).map((_) => _.props.value).join(";");
  return /* @__PURE__ */ o.jsx(gt, { ...u, children: /* @__PURE__ */ o.jsxs(
    Dt,
    {
      required: b,
      scope: n,
      trigger: h,
      onTriggerChange: w,
      valueNode: m,
      onValueNodeChange: g,
      valueNodeHasChildren: z,
      onValueNodeHasChildrenChange: M,
      contentId: be(),
      value: W,
      onValueChange: X,
      open: R,
      onOpenChange: O,
      dir: ne,
      triggerPointerDownPosRef: B,
      disabled: I,
      children: [
        /* @__PURE__ */ o.jsx(ce.Provider, { scope: n, children: /* @__PURE__ */ o.jsx(
          Lt,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: r.useCallback((_) => {
              H((D) => new Set(D).add(_));
            }, []),
            onNativeOptionRemove: r.useCallback((_) => {
              H((D) => {
                const U = new Set(D);
                return U.delete(_), U;
              });
            }, []),
            children: e
          }
        ) }),
        V ? /* @__PURE__ */ o.jsxs(
          tt,
          {
            "aria-hidden": !0,
            required: b,
            tabIndex: -1,
            name: v,
            autoComplete: x,
            value: W,
            onChange: (_) => X(_.target.value),
            disabled: I,
            form: S,
            children: [
              W === void 0 ? /* @__PURE__ */ o.jsx("option", { value: "" }) : null,
              Array.from(K)
            ]
          },
          F
        ) : null
      ]
    }
  ) });
};
Ee.displayName = Q;
var je = "SelectTrigger", Me = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, disabled: c = !1, ...l } = t, d = ue(e), s = Y(je, e), a = s.disabled || c, i = k(n, s.onTriggerChange), p = de(e), v = r.useRef("touch"), [x, I, b] = nt((u) => {
      const h = p().filter((g) => !g.disabled), w = h.find((g) => g.value === s.value), m = rt(h, u, w);
      m !== void 0 && s.onValueChange(m.value);
    }), S = (u) => {
      a || (s.onOpenChange(!0), b()), u && (s.triggerPointerDownPosRef.current = {
        x: Math.round(u.pageX),
        y: Math.round(u.pageY)
      });
    };
    return /* @__PURE__ */ o.jsx(xt, { asChild: !0, ...d, children: /* @__PURE__ */ o.jsx(
      j.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-placeholder": ot(s.value) ? "" : void 0,
        ...l,
        ref: i,
        onClick: N(l.onClick, (u) => {
          u.currentTarget.focus(), v.current !== "mouse" && S(u);
        }),
        onPointerDown: N(l.onPointerDown, (u) => {
          v.current = u.pointerType;
          const h = u.target;
          h.hasPointerCapture(u.pointerId) && h.releasePointerCapture(u.pointerId), u.button === 0 && u.ctrlKey === !1 && u.pointerType === "mouse" && (S(u), u.preventDefault());
        }),
        onKeyDown: N(l.onKeyDown, (u) => {
          const h = x.current !== "";
          !(u.ctrlKey || u.altKey || u.metaKey) && u.key.length === 1 && I(u.key), !(h && u.key === " ") && Mt.includes(u.key) && (S(), u.preventDefault());
        })
      }
    ) });
  }
);
Me.displayName = je;
var Ae = "SelectValue", Oe = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, className: c, style: l, children: d, placeholder: s = "", ...a } = t, i = Y(Ae, e), { onValueNodeHasChildrenChange: p } = i, v = d !== void 0, x = k(n, i.onValueNodeChange);
    return G(() => {
      p(v);
    }, [p, v]), /* @__PURE__ */ o.jsx(
      j.span,
      {
        ...a,
        ref: x,
        style: { pointerEvents: "none" },
        children: ot(i.value) ? /* @__PURE__ */ o.jsx(o.Fragment, { children: s }) : d
      }
    );
  }
);
Oe.displayName = Ae;
var Bt = "SelectIcon", De = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, children: c, ...l } = t;
    return /* @__PURE__ */ o.jsx(j.span, { "aria-hidden": !0, ...l, ref: n, children: c || "▼" });
  }
);
De.displayName = Bt;
var Vt = "SelectPortal", Le = (t) => /* @__PURE__ */ o.jsx(ut, { asChild: !0, ...t });
Le.displayName = Vt;
var ee = "SelectContent", ke = r.forwardRef(
  (t, n) => {
    const e = Y(ee, t.__scopeSelect), [c, l] = r.useState();
    if (G(() => {
      l(new DocumentFragment());
    }, []), !e.open) {
      const d = c;
      return d ? Ne.createPortal(
        /* @__PURE__ */ o.jsx(Be, { scope: t.__scopeSelect, children: /* @__PURE__ */ o.jsx(ce.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ o.jsx("div", { children: t.children }) }) }),
        d
      ) : null;
    }
    return /* @__PURE__ */ o.jsx(Ve, { ...t, ref: n });
  }
);
ke.displayName = ee;
var A = 10, [Be, q] = oe(ee), Ht = "SelectContentImpl", Ft = it("SelectContent.RemoveScroll"), Ve = r.forwardRef(
  (t, n) => {
    const {
      __scopeSelect: e,
      position: c = "item-aligned",
      onCloseAutoFocus: l,
      onEscapeKeyDown: d,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: a,
      sideOffset: i,
      align: p,
      alignOffset: v,
      arrowPadding: x,
      collisionBoundary: I,
      collisionPadding: b,
      sticky: S,
      hideWhenDetached: u,
      avoidCollisions: h,
      //
      ...w
    } = t, m = Y(ee, e), [g, z] = r.useState(null), [M, ne] = r.useState(null), R = k(n, (f) => z(f)), [O, W] = r.useState(null), [X, B] = r.useState(
      null
    ), V = de(e), [K, H] = r.useState(!1), F = r.useRef(!1);
    r.useEffect(() => {
      if (g) return ft(g);
    }, [g]), mt();
    const _ = r.useCallback(
      (f) => {
        const [T, ...E] = V().map((P) => P.ref.current), [C] = E.slice(-1), y = document.activeElement;
        for (const P of f)
          if (P === y || (P?.scrollIntoView({ block: "nearest" }), P === T && M && (M.scrollTop = 0), P === C && M && (M.scrollTop = M.scrollHeight), P?.focus(), document.activeElement !== y)) return;
      },
      [V, M]
    ), D = r.useCallback(
      () => _([O, g]),
      [_, O, g]
    );
    r.useEffect(() => {
      K && D();
    }, [K, D]);
    const { onOpenChange: U, triggerPointerDownPosRef: $ } = m;
    r.useEffect(() => {
      if (g) {
        let f = { x: 0, y: 0 };
        const T = (C) => {
          f = {
            x: Math.abs(Math.round(C.pageX) - ($.current?.x ?? 0)),
            y: Math.abs(Math.round(C.pageY) - ($.current?.y ?? 0))
          };
        }, E = (C) => {
          f.x <= 10 && f.y <= 10 ? C.preventDefault() : g.contains(C.target) || U(!1), document.removeEventListener("pointermove", T), $.current = null;
        };
        return $.current !== null && (document.addEventListener("pointermove", T), document.addEventListener("pointerup", E, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", T), document.removeEventListener("pointerup", E, { capture: !0 });
        };
      }
    }, [g, U, $]), r.useEffect(() => {
      const f = () => U(!1);
      return window.addEventListener("blur", f), window.addEventListener("resize", f), () => {
        window.removeEventListener("blur", f), window.removeEventListener("resize", f);
      };
    }, [U]);
    const [pe, ae] = nt((f) => {
      const T = V().filter((y) => !y.disabled), E = T.find((y) => y.ref.current === document.activeElement), C = rt(T, f, E);
      C && setTimeout(() => C.ref.current.focus());
    }), fe = r.useCallback(
      (f, T, E) => {
        const C = !F.current && !E;
        (m.value !== void 0 && m.value === T || C) && (W(f), C && (F.current = !0));
      },
      [m.value]
    ), me = r.useCallback(() => g?.focus(), [g]), te = r.useCallback(
      (f, T, E) => {
        const C = !F.current && !E;
        (m.value !== void 0 && m.value === T || C) && B(f);
      },
      [m.value]
    ), le = c === "popper" ? xe : He, re = le === xe ? {
      side: a,
      sideOffset: i,
      align: p,
      alignOffset: v,
      arrowPadding: x,
      collisionBoundary: I,
      collisionPadding: b,
      sticky: S,
      hideWhenDetached: u,
      avoidCollisions: h
    } : {};
    return /* @__PURE__ */ o.jsx(
      Be,
      {
        scope: e,
        content: g,
        viewport: M,
        onViewportChange: ne,
        itemRefCallback: fe,
        selectedItem: O,
        onItemLeave: me,
        itemTextRefCallback: te,
        focusSelectedItem: D,
        selectedItemText: X,
        position: c,
        isPositioned: K,
        searchRef: pe,
        children: /* @__PURE__ */ o.jsx(ht, { as: Ft, allowPinchZoom: !0, children: /* @__PURE__ */ o.jsx(
          vt,
          {
            asChild: !0,
            trapped: m.open,
            onMountAutoFocus: (f) => {
              f.preventDefault();
            },
            onUnmountAutoFocus: N(l, (f) => {
              m.trigger?.focus({ preventScroll: !0 }), f.preventDefault();
            }),
            children: /* @__PURE__ */ o.jsx(
              pt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: d,
                onPointerDownOutside: s,
                onFocusOutside: (f) => f.preventDefault(),
                onDismiss: () => m.onOpenChange(!1),
                children: /* @__PURE__ */ o.jsx(
                  le,
                  {
                    role: "listbox",
                    id: m.contentId,
                    "data-state": m.open ? "open" : "closed",
                    dir: m.dir,
                    onContextMenu: (f) => f.preventDefault(),
                    ...w,
                    ...re,
                    onPlaced: () => H(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: N(w.onKeyDown, (f) => {
                      const T = f.ctrlKey || f.altKey || f.metaKey;
                      if (f.key === "Tab" && f.preventDefault(), !T && f.key.length === 1 && ae(f.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(f.key)) {
                        let C = V().filter((y) => !y.disabled).map((y) => y.ref.current);
                        if (["ArrowUp", "End"].includes(f.key) && (C = C.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(f.key)) {
                          const y = f.target, P = C.indexOf(y);
                          C = C.slice(P + 1);
                        }
                        setTimeout(() => _(C)), f.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ve.displayName = Ht;
var Ut = "SelectItemAlignedPosition", He = r.forwardRef((t, n) => {
  const { __scopeSelect: e, onPlaced: c, ...l } = t, d = Y(ee, e), s = q(ee, e), [a, i] = r.useState(null), [p, v] = r.useState(null), x = k(n, (R) => v(R)), I = de(e), b = r.useRef(!1), S = r.useRef(!0), { viewport: u, selectedItem: h, selectedItemText: w, focusSelectedItem: m } = s, g = r.useCallback(() => {
    if (d.trigger && d.valueNode && a && p && u && h && w) {
      const R = d.trigger.getBoundingClientRect(), O = p.getBoundingClientRect(), W = d.valueNode.getBoundingClientRect(), X = w.getBoundingClientRect();
      if (d.dir !== "rtl") {
        const y = X.left - O.left, P = W.left - y, Z = R.left - P, J = R.width + Z, he = Math.max(J, O.width), ve = window.innerWidth - A, ge = Pe(P, [
          A,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(A, ve - he)
        ]);
        a.style.minWidth = J + "px", a.style.left = ge + "px";
      } else {
        const y = O.right - X.right, P = window.innerWidth - W.right - y, Z = window.innerWidth - R.right - P, J = R.width + Z, he = Math.max(J, O.width), ve = window.innerWidth - A, ge = Pe(P, [
          A,
          Math.max(A, ve - he)
        ]);
        a.style.minWidth = J + "px", a.style.right = ge + "px";
      }
      const B = I(), V = window.innerHeight - A * 2, K = u.scrollHeight, H = window.getComputedStyle(p), F = parseInt(H.borderTopWidth, 10), _ = parseInt(H.paddingTop, 10), D = parseInt(H.borderBottomWidth, 10), U = parseInt(H.paddingBottom, 10), $ = F + _ + K + U + D, pe = Math.min(h.offsetHeight * 5, $), ae = window.getComputedStyle(u), fe = parseInt(ae.paddingTop, 10), me = parseInt(ae.paddingBottom, 10), te = R.top + R.height / 2 - A, le = V - te, re = h.offsetHeight / 2, f = h.offsetTop + re, T = F + _ + f, E = $ - T;
      if (T <= te) {
        const y = B.length > 0 && h === B[B.length - 1].ref.current;
        a.style.bottom = "0px";
        const P = p.clientHeight - u.offsetTop - u.offsetHeight, Z = Math.max(
          le,
          re + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (y ? me : 0) + P + D
        ), J = T + Z;
        a.style.height = J + "px";
      } else {
        const y = B.length > 0 && h === B[0].ref.current;
        a.style.top = "0px";
        const Z = Math.max(
          te,
          F + u.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (y ? fe : 0) + re
        ) + E;
        a.style.height = Z + "px", u.scrollTop = T - te + u.offsetTop;
      }
      a.style.margin = `${A}px 0`, a.style.minHeight = pe + "px", a.style.maxHeight = V + "px", c?.(), requestAnimationFrame(() => b.current = !0);
    }
  }, [
    I,
    d.trigger,
    d.valueNode,
    a,
    p,
    u,
    h,
    w,
    d.dir,
    c
  ]);
  G(() => g(), [g]);
  const [z, M] = r.useState();
  G(() => {
    p && M(window.getComputedStyle(p).zIndex);
  }, [p]);
  const ne = r.useCallback(
    (R) => {
      R && S.current === !0 && (g(), m?.(), S.current = !1);
    },
    [g, m]
  );
  return /* @__PURE__ */ o.jsx(
    Wt,
    {
      scope: e,
      contentWrapper: a,
      shouldExpandOnScrollRef: b,
      onScrollButtonChange: ne,
      children: /* @__PURE__ */ o.jsx(
        "div",
        {
          ref: i,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: z
          },
          children: /* @__PURE__ */ o.jsx(
            j.div,
            {
              ...l,
              ref: x,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...l.style
              }
            }
          )
        }
      )
    }
  );
});
He.displayName = Ut;
var zt = "SelectPopperPosition", xe = r.forwardRef((t, n) => {
  const {
    __scopeSelect: e,
    align: c = "start",
    collisionPadding: l = A,
    ...d
  } = t, s = ue(e);
  return /* @__PURE__ */ o.jsx(
    St,
    {
      ...s,
      ...d,
      ref: n,
      align: c,
      collisionPadding: l,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...d.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
xe.displayName = zt;
var [Wt, Ie] = oe(ee, {}), Se = "SelectViewport", Fe = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, nonce: c, ...l } = t, d = q(Se, e), s = Ie(Se, e), a = k(n, d.onViewportChange), i = r.useRef(0);
    return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: c
        }
      ),
      /* @__PURE__ */ o.jsx(ce.Slot, { scope: e, children: /* @__PURE__ */ o.jsx(
        j.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...l,
          ref: a,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...l.style
          },
          onScroll: N(l.onScroll, (p) => {
            const v = p.currentTarget, { contentWrapper: x, shouldExpandOnScrollRef: I } = s;
            if (I?.current && x) {
              const b = Math.abs(i.current - v.scrollTop);
              if (b > 0) {
                const S = window.innerHeight - A * 2, u = parseFloat(x.style.minHeight), h = parseFloat(x.style.height), w = Math.max(u, h);
                if (w < S) {
                  const m = w + b, g = Math.min(S, m), z = m - g;
                  x.style.height = g + "px", x.style.bottom === "0px" && (v.scrollTop = z > 0 ? z : 0, x.style.justifyContent = "flex-end");
                }
              }
            }
            i.current = v.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Fe.displayName = Se;
var Ue = "SelectGroup", [Kt, $t] = oe(Ue), ze = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t, l = be();
    return /* @__PURE__ */ o.jsx(Kt, { scope: e, id: l, children: /* @__PURE__ */ o.jsx(j.div, { role: "group", "aria-labelledby": l, ...c, ref: n }) });
  }
);
ze.displayName = Ue;
var We = "SelectLabel", Ke = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t, l = $t(We, e);
    return /* @__PURE__ */ o.jsx(j.div, { id: l.id, ...c, ref: n });
  }
);
Ke.displayName = We;
var ie = "SelectItem", [Gt, $e] = oe(ie), Ge = r.forwardRef(
  (t, n) => {
    const {
      __scopeSelect: e,
      value: c,
      disabled: l = !1,
      textValue: d,
      ...s
    } = t, a = Y(ie, e), i = q(ie, e), p = a.value === c, [v, x] = r.useState(d ?? ""), [I, b] = r.useState(!1), S = k(
      n,
      (m) => i.itemRefCallback?.(m, c, l)
    ), u = be(), h = r.useRef("touch"), w = () => {
      l || (a.onValueChange(c), a.onOpenChange(!1));
    };
    if (c === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ o.jsx(
      Gt,
      {
        scope: e,
        value: c,
        disabled: l,
        textId: u,
        isSelected: p,
        onItemTextChange: r.useCallback((m) => {
          x((g) => g || (m?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ o.jsx(
          ce.ItemSlot,
          {
            scope: e,
            value: c,
            disabled: l,
            textValue: v,
            children: /* @__PURE__ */ o.jsx(
              j.div,
              {
                role: "option",
                "aria-labelledby": u,
                "data-highlighted": I ? "" : void 0,
                "aria-selected": p && I,
                "data-state": p ? "checked" : "unchecked",
                "aria-disabled": l || void 0,
                "data-disabled": l ? "" : void 0,
                tabIndex: l ? void 0 : -1,
                ...s,
                ref: S,
                onFocus: N(s.onFocus, () => b(!0)),
                onBlur: N(s.onBlur, () => b(!1)),
                onClick: N(s.onClick, () => {
                  h.current !== "mouse" && w();
                }),
                onPointerUp: N(s.onPointerUp, () => {
                  h.current === "mouse" && w();
                }),
                onPointerDown: N(s.onPointerDown, (m) => {
                  h.current = m.pointerType;
                }),
                onPointerMove: N(s.onPointerMove, (m) => {
                  h.current = m.pointerType, l ? i.onItemLeave?.() : h.current === "mouse" && m.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: N(s.onPointerLeave, (m) => {
                  m.currentTarget === document.activeElement && i.onItemLeave?.();
                }),
                onKeyDown: N(s.onKeyDown, (m) => {
                  i.searchRef?.current !== "" && m.key === " " || (At.includes(m.key) && w(), m.key === " " && m.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ge.displayName = ie;
var se = "SelectItemText", Ye = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, className: c, style: l, ...d } = t, s = Y(se, e), a = q(se, e), i = $e(se, e), p = kt(se, e), [v, x] = r.useState(null), I = k(
      n,
      (w) => x(w),
      i.onItemTextChange,
      (w) => a.itemTextRefCallback?.(w, i.value, i.disabled)
    ), b = v?.textContent, S = r.useMemo(
      () => /* @__PURE__ */ o.jsx("option", { value: i.value, disabled: i.disabled, children: b }, i.value),
      [i.disabled, i.value, b]
    ), { onNativeOptionAdd: u, onNativeOptionRemove: h } = p;
    return G(() => (u(S), () => h(S)), [u, h, S]), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(j.span, { id: i.textId, ...d, ref: I }),
      i.isSelected && s.valueNode && !s.valueNodeHasChildren ? Ne.createPortal(d.children, s.valueNode) : null
    ] });
  }
);
Ye.displayName = se;
var qe = "SelectItemIndicator", Xe = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t;
    return $e(qe, e).isSelected ? /* @__PURE__ */ o.jsx(j.span, { "aria-hidden": !0, ...c, ref: n }) : null;
  }
);
Xe.displayName = qe;
var we = "SelectScrollUpButton", Ze = r.forwardRef((t, n) => {
  const e = q(we, t.__scopeSelect), c = Ie(we, t.__scopeSelect), [l, d] = r.useState(!1), s = k(n, c.onScrollButtonChange);
  return G(() => {
    if (e.viewport && e.isPositioned) {
      let a = function() {
        const p = i.scrollTop > 0;
        d(p);
      };
      const i = e.viewport;
      return a(), i.addEventListener("scroll", a), () => i.removeEventListener("scroll", a);
    }
  }, [e.viewport, e.isPositioned]), l ? /* @__PURE__ */ o.jsx(
    Qe,
    {
      ...t,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: i } = e;
        a && i && (a.scrollTop = a.scrollTop - i.offsetHeight);
      }
    }
  ) : null;
});
Ze.displayName = we;
var Ce = "SelectScrollDownButton", Je = r.forwardRef((t, n) => {
  const e = q(Ce, t.__scopeSelect), c = Ie(Ce, t.__scopeSelect), [l, d] = r.useState(!1), s = k(n, c.onScrollButtonChange);
  return G(() => {
    if (e.viewport && e.isPositioned) {
      let a = function() {
        const p = i.scrollHeight - i.clientHeight, v = Math.ceil(i.scrollTop) < p;
        d(v);
      };
      const i = e.viewport;
      return a(), i.addEventListener("scroll", a), () => i.removeEventListener("scroll", a);
    }
  }, [e.viewport, e.isPositioned]), l ? /* @__PURE__ */ o.jsx(
    Qe,
    {
      ...t,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: i } = e;
        a && i && (a.scrollTop = a.scrollTop + i.offsetHeight);
      }
    }
  ) : null;
});
Je.displayName = Ce;
var Qe = r.forwardRef((t, n) => {
  const { __scopeSelect: e, onAutoScroll: c, ...l } = t, d = q("SelectScrollButton", e), s = r.useRef(null), a = de(e), i = r.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return r.useEffect(() => () => i(), [i]), G(() => {
    a().find((v) => v.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ o.jsx(
    j.div,
    {
      "aria-hidden": !0,
      ...l,
      ref: n,
      style: { flexShrink: 0, ...l.style },
      onPointerDown: N(l.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(c, 50));
      }),
      onPointerMove: N(l.onPointerMove, () => {
        d.onItemLeave?.(), s.current === null && (s.current = window.setInterval(c, 50));
      }),
      onPointerLeave: N(l.onPointerLeave, () => {
        i();
      })
    }
  );
}), Yt = "SelectSeparator", et = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t;
    return /* @__PURE__ */ o.jsx(j.div, { "aria-hidden": !0, ...c, ref: n });
  }
);
et.displayName = Yt;
var ye = "SelectArrow", qt = r.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t, l = ue(e), d = Y(ye, e), s = q(ye, e);
    return d.open && s.position === "popper" ? /* @__PURE__ */ o.jsx(wt, { ...l, ...c, ref: n }) : null;
  }
);
qt.displayName = ye;
var Xt = "SelectBubbleInput", tt = r.forwardRef(
  ({ __scopeSelect: t, value: n, ...e }, c) => {
    const l = r.useRef(null), d = k(c, l), s = yt(n);
    return r.useEffect(() => {
      const a = l.current;
      if (!a) return;
      const i = window.HTMLSelectElement.prototype, v = Object.getOwnPropertyDescriptor(
        i,
        "value"
      ).set;
      if (s !== n && v) {
        const x = new Event("change", { bubbles: !0 });
        v.call(a, n), a.dispatchEvent(x);
      }
    }, [s, n]), /* @__PURE__ */ o.jsx(
      j.select,
      {
        ...e,
        style: { ...bt, ...e.style },
        ref: d,
        defaultValue: n
      }
    );
  }
);
tt.displayName = Xt;
function ot(t) {
  return t === "" || t === void 0;
}
function nt(t) {
  const n = Ct(t), e = r.useRef(""), c = r.useRef(0), l = r.useCallback(
    (s) => {
      const a = e.current + s;
      n(a), (function i(p) {
        e.current = p, window.clearTimeout(c.current), p !== "" && (c.current = window.setTimeout(() => i(""), 1e3));
      })(a);
    },
    [n]
  ), d = r.useCallback(() => {
    e.current = "", window.clearTimeout(c.current);
  }, []);
  return r.useEffect(() => () => window.clearTimeout(c.current), []), [e, l, d];
}
function rt(t, n, e) {
  const l = n.length > 1 && Array.from(n).every((p) => p === n[0]) ? n[0] : n, d = e ? t.indexOf(e) : -1;
  let s = Zt(t, Math.max(d, 0));
  l.length === 1 && (s = s.filter((p) => p !== e));
  const i = s.find(
    (p) => p.textValue.toLowerCase().startsWith(l.toLowerCase())
  );
  return i !== e ? i : void 0;
}
function Zt(t, n) {
  return t.map((e, c) => t[(n + c) % t.length]);
}
var Jt = Ee, Qt = Me, eo = Oe, to = De, oo = Le, no = ke, ro = Fe, so = ze, ao = Ke, lo = Ge, io = Ye, co = Xe, uo = Ze, po = Je, fo = et;
function mo({
  ...t
}) {
  return /* @__PURE__ */ o.jsx(Jt, { "data-slot": "select", ...t });
}
function ho({
  ...t
}) {
  return /* @__PURE__ */ o.jsx(so, { "data-slot": "select-group", ...t });
}
function vo({
  ...t
}) {
  return /* @__PURE__ */ o.jsx(eo, { "data-slot": "select-value", ...t });
}
function go({
  className: t,
  size: n = "sm",
  children: e,
  ...c
}) {
  return /* @__PURE__ */ o.jsxs(
    Qt,
    {
      "data-slot": "select-trigger",
      "data-size": n,
      className: L(
        "border-border data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-background/30 dark:hover:bg-background/50 flex w-fit items-center justify-between gap-4 rounded-md border bg-white px-5 py-4 whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-6",
        t
      ),
      ...c,
      children: [
        e,
        /* @__PURE__ */ o.jsx(to, { asChild: !0, children: /* @__PURE__ */ o.jsx(_e, { className: "size-6 opacity-50" }) })
      ]
    }
  );
}
function xo({
  className: t,
  ...n
}) {
  return /* @__PURE__ */ o.jsx(
    uo,
    {
      "data-slot": "select-scroll-up-button",
      className: L("flex cursor-default items-center justify-center py-1", t),
      ...n,
      children: /* @__PURE__ */ o.jsx(jt, { className: "size-6" })
    }
  );
}
function So({
  className: t,
  ...n
}) {
  return /* @__PURE__ */ o.jsx(
    po,
    {
      "data-slot": "select-scroll-down-button",
      className: L("flex cursor-default items-center justify-center py-1", t),
      ...n,
      children: /* @__PURE__ */ o.jsx(_e, { className: "size-6" })
    }
  );
}
function wo({
  className: t,
  children: n,
  position: e = "popper",
  ...c
}) {
  const l = at((d) => {
    if (d) {
      const s = parseInt(
        window.getComputedStyle(d).getPropertyValue("--radix-popper-available-height").replace("px", "")
      ), a = d.getBoundingClientRect();
      if (!isNaN(s) && s < a.height) {
        const i = d.getAttribute("data-side");
        i === "top" ? (d.style.maxHeight = `calc(100vh - ${a.bottom}px)`, d.style.overflow = "auto") : i === "bottom" && (d.style.maxHeight = `calc(100vh - ${a.top}px)`, d.style.overflow = "auto");
      }
    }
  }, []);
  return /* @__PURE__ */ o.jsx(oo, { children: /* @__PURE__ */ o.jsxs(
    no,
    {
      ref: (d) => {
        l(d);
      },
      "data-slot": "select-content",
      className: L(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md",
        e === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        t
      ),
      position: e,
      ...c,
      children: [
        /* @__PURE__ */ o.jsx(xo, {}),
        /* @__PURE__ */ o.jsx(
          ro,
          {
            className: L(
              "p-1",
              e === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: n
          }
        ),
        /* @__PURE__ */ o.jsx(So, {})
      ]
    }
  ) });
}
function Co({
  className: t,
  ...n
}) {
  return /* @__PURE__ */ o.jsx(
    ao,
    {
      "data-slot": "select-label",
      className: L("text-muted-foreground px-2 py-1.5", t),
      ...n
    }
  );
}
function yo({
  className: t,
  children: n,
  ...e
}) {
  return /* @__PURE__ */ o.jsxs(
    lo,
    {
      "data-slot": "select-item",
      className: L(
        "focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-6 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        t
      ),
      ...e,
      children: [
        /* @__PURE__ */ o.jsx("span", { className: "absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ o.jsx(co, { children: /* @__PURE__ */ o.jsx(It, { className: "size-5" }) }) }),
        /* @__PURE__ */ o.jsx(io, { children: n })
      ]
    }
  );
}
function bo({
  className: t,
  ...n
}) {
  return /* @__PURE__ */ o.jsx(
    fo,
    {
      "data-slot": "select-separator",
      className: L("bg-grey-300 pointer-events-none -mx-1 my-1 h-2", t),
      ...n
    }
  );
}
const Io = _t("", {
  variants: {
    height: {
      tall: "min-h-10"
    },
    width: {
      sm: "w-[144px]",
      "max-sm": "w-full max-w-[144px]",
      md: "w-[240px]",
      "max-md": "w-full max-w-[240px]",
      lg: "w-[360px]",
      "max-lg": "w-full max-w-[360px]",
      full: "w-full"
    }
  },
  defaultVariants: {
    width: "sm"
  }
}), To = "flex flex-col md:flex-row md:items-center", Po = st.forwardRef(
  ({
    id: t,
    selectList: n,
    selectLabel: e,
    triggerLabel: c,
    helperText: l,
    error: d,
    spacing: s,
    width: a,
    height: i,
    inlineLabel: p = !1,
    ...v
  }, x) => /* @__PURE__ */ o.jsxs(
    Rt,
    {
      className: L(
        Pt(s),
        p ? To : "",
        "overflow-hidden"
      ),
      children: [
        /* @__PURE__ */ o.jsx(
          Nt,
          {
            variant: p ? "inline" : "visible",
            ...e,
            helperText: l,
            htmlFor: t
          }
        ),
        /* @__PURE__ */ o.jsxs(mo, { ...v, children: [
          /* @__PURE__ */ o.jsx(
            go,
            {
              id: t,
              ref: x,
              className: L(
                Io({ width: a, height: i }),
                "[&>span:first-child]:truncate"
              ),
              children: /* @__PURE__ */ o.jsx(vo, { placeholder: c })
            }
          ),
          /* @__PURE__ */ o.jsx(wo, { children: n.map((I, b) => /* @__PURE__ */ o.jsxs(ho, { children: [
            I.groupLabel && /* @__PURE__ */ o.jsx(Co, { children: I.groupLabel }),
            I.items.map((S, u) => /* @__PURE__ */ o.jsx(yo, { value: S.value, children: S.itemLabel }, u)),
            b !== n.length - 1 && /* @__PURE__ */ o.jsx(bo, {})
          ] }, `group-${b}`)) })
        ] }),
        d
      ]
    }
  )
);
Po.displayName = "Select";
export {
  Po as default
};
